export const Divisions = {
  Minerals: 2,
  Food: 6,
  BVAQ: 8,
};
